import React from 'react';
import styled from 'styled-components';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

import Button from 'kingpin/atoms/Button';

export const ButtonPosition = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 999999999999;
`;

// Shown on a TV when the mouse moves. Also used by the screenshot
// WallboardPlayer, so it lives outside WallBoard.tsx (which pulls in the whole
// dashboard tree).
export const SignOutButton = () => {
  const onClick = () => {
    if (
      window.confirm(
        'You will need to get a new access token to set up this wallboard' +
          ' again. Are you sure?',
      )
    ) {
      firebase.auth().signOut();
    }
  };

  return (
    <ButtonPosition>
      <Button size={'Medium'} type={'Primary'} onClick={onClick} icon="cross" />
    </ButtonPosition>
  );
};
